import httpClient from "../http/http-client";
import { IArchivedReportPeriod, IPostArchivedReportPeriod } from './archived-report-period.model';

export default class ArchivedReportPeriodService {
  http;

  constructor() {
    this.http = httpClient
  }

  async createArchivedReportPeriod(details: IPostArchivedReportPeriod): Promise<IPostArchivedReportPeriod> {
    return this.http.post('archived-report-period', details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async editArchivedReportPeriod(id: string, details: IPostArchivedReportPeriod): Promise<IPostArchivedReportPeriod> {
    return this.http.patch(`archived-report-period/${id}`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async deleteArchivedReportPeriod(id: string): Promise<IPostArchivedReportPeriod> {
    return this.http.delete(`archived-report-period/${id}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async getAllArchivedReportPeriods(): Promise<IArchivedReportPeriod[]> {
    return this.http.get(`archived-report-period`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getOneArchivedReportPeriod(id: string): Promise<IArchivedReportPeriod> {
    return this.http.get(`archived-report-period/${id}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }
}